import Cookie from 'js-cookie';
import { req } from 'react-reqq-lite';

import { withAclReq } from 'modules/partial/hooks';

import * as c from './constant';
import { transformMerchant } from '../settings/store-profile/transformer';

const userType = Cookie.get('_userType');

export const getMerchantProfile = (
  merchant_uuid,
  callback = () => {},
  ecb = () => {}
) => {
  req.get(
    withAclReq(
      () => ({
        ADMIN: {
          url: `/v1/vendors/${merchant_uuid}`,
        },
        MERCHANT: {
          url: '/v1/me/profile',
        },
      }),
      {
        key: c.GET_MERCHANT_PROFILE,
        transform: ({ data, included }) => {
          const x = transformMerchant(data, included);
          return x;
        },
        onSuccess: ({ response: { included } }) => {
          if (userType === 'MERCHANT') {
            const vendor_users =
              included?.find((x) => x?.type === 'vendor_users') || {};
            const vendor_subscriptions = included?.find(
              (x) => x?.type === 'vendor_subscriptions'
            );
            const { show_tutorial, tutorial_step } =
              vendor_users?.attributes || {};
            const { system_status } = vendor_subscriptions?.attributes || {};

            Cookie.set('_tutorial_step', tutorial_step);
            Cookie.set('_show_tutorial', show_tutorial);
            Cookie.set('_subscription', system_status);
          }
          callback();
        },
        onError: (err) => {
          ecb(err);
        },
      }
    )
  );
};
